import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  listarEtapas,
  atualizarEtapa,
  listarEventos,
  contarEventos,
  testarSMTP,
} from '../../../services/cobrancaService';

const initialState = {
  etapas: [],
  eventos: [],
  contadores: { total_30d: 0, enviado_30d: 0, erro_30d: 0, pulado_30d: 0, enfileirado_30d: 0 },
  smtpInfo: null,
  loadingEtapas: false,
  loadingEventos: false,
  loadingContadores: false,
  error: null,
};

export const fetchEtapas = createAsyncThunk(
  'cobranca/fetchEtapas',
  async () => listarEtapas(),
);

export const fetchEventos = createAsyncThunk(
  'cobranca/fetchEventos',
  async (params) => listarEventos(params || {}),
);

export const fetchContadores = createAsyncThunk(
  'cobranca/fetchContadores',
  async () => contarEventos(),
);

export const fetchSMTPInfo = createAsyncThunk(
  'cobranca/fetchSMTPInfo',
  async () => testarSMTP(),
);

export const atualizarEtapaThunk = createAsyncThunk(
  'cobranca/atualizarEtapa',
  async ({ id, payload }, { dispatch }) => {
    const resp = await atualizarEtapa(id, payload);
    dispatch(fetchEtapas());
    return resp;
  },
);

const CobrancaSlice = createSlice({
  name: 'cobranca',
  initialState,
  reducers: {
    limparErro: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEtapas.pending, (s) => { s.loadingEtapas = true; })
      .addCase(fetchEtapas.fulfilled, (s, a) => {
        s.loadingEtapas = false;
        s.etapas = a.payload || [];
      })
      .addCase(fetchEtapas.rejected, (s, a) => {
        s.loadingEtapas = false;
        s.error = a.error?.message || 'Falha ao carregar etapas';
      })

      .addCase(fetchEventos.pending, (s) => { s.loadingEventos = true; })
      .addCase(fetchEventos.fulfilled, (s, a) => {
        s.loadingEventos = false;
        s.eventos = a.payload || [];
      })
      .addCase(fetchEventos.rejected, (s, a) => {
        s.loadingEventos = false;
        s.error = a.error?.message || 'Falha ao carregar eventos';
      })

      .addCase(fetchContadores.pending, (s) => { s.loadingContadores = true; })
      .addCase(fetchContadores.fulfilled, (s, a) => {
        s.loadingContadores = false;
        s.contadores = a.payload || initialState.contadores;
      })
      .addCase(fetchContadores.rejected, (s) => { s.loadingContadores = false; })

      .addCase(fetchSMTPInfo.fulfilled, (s, a) => {
        s.smtpInfo = a.payload || null;
      });
  },
});

export const { limparErro } = CobrancaSlice.actions;
export default CobrancaSlice.reducer;
